var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNew)?_c('Export2',{on:{"toggleUi":function($event){_vm.isNew = $event}}}):_c('Export',{on:{"toggleUi":function($event){_vm.isNew = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }